import React from "react";
import { InfoPopover } from "@/components/vb";
import { SIGNAL_GROUP_LABELS } from "./signalMeta";
import type { VerdictModel } from "./verdictModel";

/** Right-hand panel of the verdict header: how many of the 19 AI Trust Signals
 *  AI surfaced, a coverage meter, and the surfaced signals grouped by bucket with
 *  an "absent" tail per group. Surfaced/absent come straight from the judgment. */
export function SignalExposurePanel({ exposure }: { exposure: VerdictModel["exposure"] }) {
  const { surfacedCount, absentCount, total, groups } = exposure;
  return (
    <div className="vb-sigpanel">
      <div className="vb-sigpanel__hd">
        <span className="vb-sigpanel__lbl">AI Trust Signals in the responses</span>
        <InfoPopover label="About AI Trust Signals in the responses">
          Each AI answer is judged against your {total} AI Trust Signals. A signal is
          surfaced when an answer shows concrete evidence of it for your company.
        </InfoPopover>
        <div className="vb-sigpanel__stats">
          <span>
            <span className="vb-sigpanel__surfaced tnum">{surfacedCount}</span> surfaced
          </span>
          <span>
            <span className="vb-sigpanel__absent tnum">{absentCount}</span> absent
          </span>
        </div>
      </div>

      <div
        className="vb-sig-meter"
        role="img"
        aria-label={`${surfacedCount} of ${total} AI Trust Signals surfaced`}
      >
        {Array.from({ length: total }).map((_, i) => (
          <span key={i} className={i < surfacedCount ? "vb-sig-meter__seg is-on" : "vb-sig-meter__seg"} />
        ))}
      </div>

      {groups.map((g) => (
        <div className="vb-sig-row" key={g.group}>
          <span className="vb-sig-row__cat">{SIGNAL_GROUP_LABELS[g.group]}</span>
          <div className="vb-sig-row__pills">
            {g.surfaced.map((s) => (
              <span className="vb-signal-pill" key={s.key}>
                {s.name}
              </span>
            ))}
            {g.absentCount > 0 && (
              <span className="vb-signal-pill vb-signal-pill--count">+{g.absentCount} absent</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default SignalExposurePanel;
